const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgIconEditar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.56 18.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3a47;}")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_editar",
    "data-name": "Icon editar"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.29,18.58H.46A.47.47,0,0,1,0,18.11V2.27a.46.46,0,0,1,.46-.46H7.92v.92h-7V17.65H15.82v-7h.93v7.47A.47.47,0,0,1,16.29,18.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.28,12.25H6.79a.47.47,0,0,1-.47-.47V8.29A.44.44,0,0,1,6.46,8L14.27.13a.49.49,0,0,1,.66,0l3.49,3.5a.46.46,0,0,1,0,.65l-7.81,7.83A.47.47,0,0,1,10.28,12.25Zm-3-.93h2.84L17.44,4,14.6,1.12,7.25,8.48Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditar);
export default __webpack_public_path__ + "static/media/Icon_editar.ceb672eb9d55756368cfc60bc6f93908.svg";
export { ForwardRef as ReactComponent };